import { Component } from '@angular/core';

@Component({
    selector: 'under-construction',
    templateUrl: './under-construction.component.html',
    styleUrls: ['./under-construction.component.scss'],
    standalone: false
})
export class UnderConstructionComponent {

}

